export default "__VITE_ASSET__CsSmTi8G__"